export enum Role {
    User = 'EndUser',
  Admin = 'Admin',
  ReadOnly='ReadOnly'
}
